import { useContext, memo } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { TournamentContext } from 'src/contexts/docs/TournamentContext';
import { ImageOptimized } from '../../image/ImageOptimized';

export const IMG_URL_DEFAULT =
  '/assets/images/tournament-calendar/img-url-default.png';
export const SPONSOR_IMG_URL_DEFAULT = '/assets/images/logo.svg';

const TournamentCardImageryUnmemoized: React.FC = () => {
  const { tournamentThumbnailImgUrl = IMG_URL_DEFAULT, sponsors } =
    useContext(TournamentContext);
  const theme = useTheme();
  const sponsorCount = sponsors?.length || 0;
  const sponsorHeight = 94 / sponsorCount;

  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: 'space-evenly',
        alignItems: 'center',
        gap: '8px',
        display: 'flex',
      }}
    >
      <ImageOptimized
        src={tournamentThumbnailImgUrl}
        height={103}
        width={240}
        style={{ borderRadius: '5px' }}
      />
      <Box
        position="relative"
        width={48}
        sx={{
          background: theme.palette.background.elevation[14],
          borderRadius: '5px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {sponsors?.map((sponsor, index) => {
          const sponsorImgUrl = sponsor.imgUrl || SPONSOR_IMG_URL_DEFAULT;
          return (
            <ImageOptimized
              key={index}
              layout="fixed"
              height={sponsorHeight}
              width={48}
              objectFit="contain"
              src={sponsorImgUrl}
              style={{ borderRadius: '5px' }}
            />
          );
        })}
      </Box>
    </Stack>
  );
};

export const TournamentCardImagery = memo(TournamentCardImageryUnmemoized);
